import type { UnionOfPropertyTypes } from '@backmarket/utils/object/UnionOfPropertyTypes'

/**
 * Stable identifier of a payment advertising configuration.
 *
 * The identifier is **not** necessarily the same as a payment method code.
 * Example: `klarnaAll` is used to define a advertising configuration that applies when all Klarna methods are available.
 */
export const PaymentAdvertisingId = {
  PAYPAL: 'paypal',
  AFFIRM: 'affirm',
  KLARNA_ONE_OF: 'klarnaOneOf',
  KLARNA_ALL: 'klarnaAll',
  KLARNA_SLICE_IT: 'klarnaSliceIt',
  KLARNA_PAY_LATER: 'klarnaPayLater',
  ONEY_GENERIC: 'oneyGeneric',
} as const

export type PaymentAdvertisingId = UnionOfPropertyTypes<
  typeof PaymentAdvertisingId
>
